import { fn, FixupRelPath } from '@common/utils';
import { IKWFRoute } from '../KWFMain';
import { KWFApplicationService, RwfInvoiceDataService } from '../KWFApplication';
import { IRwfSettings, IRwfBootstrapParameters, RwfBootstrap } from '@common/rwf';
import { Param_NavUrl, Param_Company } from '@common/services/autoresolveservice';

export class CtrlStartPage {
    static readonly Route: IKWFRoute = {
        DescriptionFormula: "::KWFSettings.CurrentCompany",
        name: "",
        controller: CtrlStartPage,
        template: require('./infotiles.html'),
        resolve: {
            "RwfBootstrapParameters" : ["RwfBootstrap", (rwf: RwfBootstrap) => rwf.Resolve],
            // Defer Invoicedata Resolution after App Resolution (deadlock otherwise ...)
            "RwfInvoiceDataResolved": ["KWFApplication", "RwfInvoiceData",
                (rwfApp: KWFApplicationService, invoiceData: RwfInvoiceDataService) => rwfApp.EnsureResolved().then(() => invoiceData.Resolve)],
        },
        AllowChangeCompany: true
    };
    static $inject = ["$scope", "$location", "KWFApplication", "RwfInvoiceDataResolved", "RwfBootstrapParameters"];
    constructor(
        $scope: IStartPageScope,
        $location: ng.ILocationService,
        KWFApplication: KWFApplicationService,
        InvoiceData: RwfInvoiceDataService,
        RwfBootstrapParameters: IRwfBootstrapParameters
    ) {
        $scope["InvoiceData"] = InvoiceData;
        $scope.GlobalSettings = KWFApplication.LoadedSettings;
        $scope["MyInvoices"] = InvoiceData.MyInvoices;
        $scope["AllInvoices"] = InvoiceData.AllInvoices;
        $scope["InvolvedInvoices"] = InvoiceData.InvolvedInvoices;
        if (typeof RwfBootstrapParameters.RwfSetup.IsFWFActive === "boolean") {
            $scope["FWFItems"] = InvoiceData.FWFItems;
            $scope["FWFAllItems"] = InvoiceData.FWFAllItems;
        } else {
            let waitFWfItems = $scope.$watch(() => InvoiceData.FWFItems?.TotalCount, (newValue) => {
                if (!isNaN(newValue) && newValue > 0) {
                    waitFWfItems();
                    $scope["FWFItems"] = InvoiceData.FWFItems;
                  }
            });
            let waitFWAllfItems = $scope.$watch(() => InvoiceData.FWFAllItems?.TotalCount, (newValue) => {
              if (!isNaN(newValue) && newValue > 0) {
                waitFWAllfItems();
                  $scope["FWFAllItems"] = InvoiceData.FWFAllItems;
                }
          });

        }
        $scope.StartRefresh = StartRefreshCycle;

        var s = $location.search(),
            addParams = KWFApplicationService && fn.EncodeQueryData(fn.ToDictionaryEx([Param_NavUrl, Param_Company], p => p, p => s[p]));

        $scope["LocationParamsRaw"] = (addParams && ("?" + addParams)) || "";
        $scope["LocationParams"] = (addParams && ("&" + addParams)) || "";

        $scope["Path"] = FixupRelPath;
        // Implicitly Start Refresh Cycle
        StartRefreshCycle();
        /** Currently Running Refresh Cycle */
        var currentRefresh: PromiseLike<any>;

        /** Start New Refresh igf none is running */
        function StartRefreshCycle() {
            if (currentRefresh == null) {
                const reset = () => {
                    if (startedRefresh == currentRefresh)
                        currentRefresh = null;
                };
                var startedRefresh = currentRefresh = InvoiceData.RefreshInvoiceData(true).then(reset, reset);
            }

            return currentRefresh;
        }

        // Refresh Visualization when other user end edit item
        $scope.$on("$destroy", InvoiceData.ActRefreshInvoiceData.ActivateAutoRefresh());
    }
}

export interface IStartPageScope extends ng.IScope {
    /** Global Settings, Loaded Async */
    GlobalSettings: IRwfSettings;

    /** Start a Refresh Cycle (if a Refresh Cycle is alreada in progress, the current one is returned */
    StartRefresh(): PromiseLike<void>;
}

//#region Link Icon Control

export const LinkIcon = [function LinkIcon(): ng.IDirective {
    return {
        restrict: "E",
        scope: {
            linkurl: "=",
            iconclass: "=",
            target: "="
        },
        template: require('./linkicon.fragment.html')
    };
}];

//#endregion

//#region Tile Control

export const Tile = ["TileSettings", function Tile(settings: ITileSettings): ng.IDirective {
    return {
        restrict: "E",
        scope: {
            caption: "=",
            description: "=",
            count: "=",
            iconclass: "=",
            url: "=",
        },
        link: ($scope: any) => {
            var threshold = settings.Thresholds;
            $scope.$watch("count",
                (newVal) => $scope.countimage = countimage(newVal));
            function countimage(counter: number) {

                if (counter >= threshold.Large) {
                    return "idms_Image_StackXLarge";
                }
                else if (counter >= threshold.Medium) {
                    return "idms_Image_StackLarge";
                }
                else if (counter >= threshold.Small) {
                    return "idms_Image_StackMedium";
                }
                else if (counter > 0) {
                    return "idms_Image_StackSmall";
                }
                else {
                    return "idms_Image_StackZero";
                }
            };
        },
        template: require('./tile.fragment.html')
    };
}];

/** Settings for Tiles */
export interface ITileSettings {
    Thresholds: {
        Small: number, Medium: number, Large: number
    };
}
